<template>
  <div class="sales">
    <div>
      <h3>Month to Date Sales</h3>
      <div class="transaction-amount-loader" v-if="!salesValue"></div>
      <h4>{{ salesValue }}</h4>
    </div>
    <div></div>
  </div>
</template>

<script>
import { API, graphqlOperation } from "aws-amplify";
import dayjs from "dayjs";
import { getTransactionAmountTotal } from "../../../../graphql/queries";
export default {
  data() {
    return {
      salesValue: null,
      startDate: dayjs().format("YYYY-MM"),
      endDate: dayjs().format("YYYY-MM-DD"),
      databaseType: "NetTotal"
    };
  },
  methods: {
    currencyFormatter(number) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      });

      return formatter.format(number);
    },
    async getSalesTotal() {
      const searchResponse = await API.graphql(
        graphqlOperation(getTransactionAmountTotal, {
          query: {
            startDate: this.startDate,
            endDate: this.endDate,
            databaseType: this.databaseType
          }
        })
      );
      this.salesValue = this.currencyFormatter(
        searchResponse.data.getTransactionAmountTotal.Total
      );
    }
  },
  async mounted() {
    await this.getSalesTotal();
  }
};
</script>
